import { createApp } from 'vue';
import projectHeroBannerApp from '@/app/views/project-hero-banner-map/project-hero-banner-map.vue';
import store from '@/app/store';

function init(): void {
  const projectHeroBannerMapEl = document.getElementById('project-hero-banner-map');
  if (projectHeroBannerMapEl) {
    const app = createApp(projectHeroBannerApp);
    app.use(store);
    app.provide('config', SSENT);
    app.provide('storeName', 'projectHeroBanner');
    app.mount(projectHeroBannerMapEl);
  }
}

export default init;
